import styled from 'styled-components';
import { colors } from 'shared/defaultTheme';

export const DivCustom = styled.div`
  border-radius: 4px;
  border: 1px solid ${colors.gullGrey};
  height: 32px;
  padding-left: 8px;
  &:active,
  &:focus {
    border-color: ${colors.black} !important;
  }
  .e-input-group:not(.e-float-icon-left):not(.e-float-input)::before,
  .e-input-group:not(.e-float-icon-left):not(.e-float-input)::after,
  .e-input-group.e-float-icon-left:not(.e-float-input) .e-input-in-wrap::before,
  .e-input-group.e-float-icon-left:not(.e-float-input) .e-input-in-wrap::after,
  .e-input-group.e-control-wrapper:not(.e-float-icon-left):not(.e-float-input)::before,
  .e-input-group.e-control-wrapper:not(.e-float-icon-left):not(.e-float-input)::after,
  .e-input-group.e-control-wrapper.e-float-icon-left:not(.e-float-input) .e-input-in-wrap::before,
  .e-input-group.e-control-wrapper.e-float-icon-left:not(.e-float-input) .e-input-in-wrap::after {
    background: none;
  }
  .e-input-group {
    border: none !important;
  }
  .e-input-group .e-input-group-icon,
  .e-input-group.e-control-wrapper .e-input-group-icon {
    font-size: 18px;
    margin-right: -4px;
  }
  .e-date-wrapper {
    span.e-input-group-icon.e-date-icon.e-icons.e-active {
      color: ${colors.black};
    }
    .e-input-group-icon.e-icons.e-active {
      color: ${colors.black};
    }
    .e-input-group:not(.e-disabled) .e-input-group-icon.e-icons.e-active:active {
      color: ${colors.black};
    }
    .e-input-group-icon .e-date-icon .e-icons.e-active {
      color: ${colors.black};
    }

    .e-time-icon.e-icons::before {
      font-size: 18px;
    }
    .e-clear-icon::before {
      padding-right: 4px;
      content: '\\e935' !important;
      font-family: 'lf-font', sans-serif !important;
      font-size: 1.125rem !important;
    }
  }
  .e-input-group input.e-input,
  .e-input-group.e-control-wrapper input.e-input,
  .e-input-group textarea.e-input,
  .e-input-group.e-control-wrapper textarea.e-input {
    pointer-events: none;
  }
`;
